import { call, options } from './helpers';

export const updateOrganization = (payload) =>
	call(`/beta/users/updateOrganization`, options(payload, 'PUT'));

export const userLogin = (payload) =>
	call(`/beta/users/authenticate`, options(payload, 'POST'));

export const userLoginWithSSO = (payload) =>
	call(`/beta/users/authenticate/sso`, options(payload, 'POST'));

export const userLogout = () => localStorage.removeItem('user');

export const userResetToken = (payload) =>
	call(`/beta/users/forgotPassword`, options(payload, 'POST'));

export const userFetchAccessToken = (payload) =>
	call(`/beta/users/accessToken`, options(payload, 'POST'));

export const userCreate = (payload) =>
	call(`/beta/users`, options(payload, 'POST'));

export const userUpdate = (payload) =>
	call(`/beta/users`, options(payload, 'PUT'));

export const verifyResetToken = (payload) =>
	call(`/beta/users/verifyResetToken`, options(payload, 'POST'));

export const resetPassword = (payload) =>
	call(`/beta/users/resetPassword`, options(payload, 'POST'));

export const activateUser = (payload) =>
	call(`/beta/users/activate`, options(payload, 'PUT'));

export const deactivateUser = (payload) =>
	call(`/beta/users/deactivate`, options(payload, 'PUT'));

export const removeUser = (payload) =>
	call(`/beta/users/remove`, options(payload, 'PUT'));

export const deactivateSelf = () =>
	call(`/v2/users/status/deactivate`, options(null, 'PATCH'));

export const getAllAvailableTimezones = () => call(`/v2/timezones`);

export const updateUserProfilev2 = (payload) =>
	call(`/v2/users`, options(payload, 'PUT'));

export const updateUserPasswordv2 = (payload) =>
	call(`/v2/users/password`, options(payload, 'PATCH'));
